import type {
  IActivityLogPhaseResponse,
  IExecutionDashboardResponse,
  ITestPlanResponse,
} from '../../interfaces/api/responses/runResults.response';
import type {
  IActivityLogPhase,
  IExecutionDashboard,
  ITestSuite,
} from '../../interfaces/ui';

const phaseLabels: Record<string, string> = {
  'scout-heal': 'Scout & Heal',
  context: 'Context',
  plan: 'Plan',
  generate: 'Generate',
  run: 'Run',
};

export function toActivityLogPhase(
  response: IActivityLogPhaseResponse,
): IActivityLogPhase {
  return {
    phase: phaseLabels[response.phase] || response.phase,
    status: response.status,
    events: response.events,
    startTime: response.startTs,
    endTime: response.endTs,
    durationSeconds: response.durationSec,
  };
}

export function toExecutionDashboard(
  response: IExecutionDashboardResponse,
): IExecutionDashboard {
  return {
    status: response.status,
    dashboardUrl: response.data.dashboardUrl,

    // projectId: response.projectId,
    // passed: response.passed,
    // failed: response.failed,
    // generated: response.generated,
    // healed: response.healed,
    // suiteVersion: response.suiteVersion,
    // reportUrl: response.dashboard.reportUrl,
    // dashboardUrl: response.dashboard.dashboardUrl,
    // sessionId: response.dashboard.sessionId,
  };
}

export function toTestSuites(response: ITestPlanResponse): ITestSuite[] {
  const suites = response.data?.suites ?? response.suites ?? [];

  return suites.map((suite, suiteIndex) => ({
    name: suite.name || `Suite ${suiteIndex + 1}`,
    tests: (suite.tests || []).map((test, testIndex) => ({
      name: test.title || test.name || `Test ${testIndex + 1}`,
      title: test.title || test.name || `Test ${testIndex + 1}`,
      preconditions: test.preconditions || [],
      date: test.date,
      specPath: test.specPath,
      steps: (test.steps || []).map(step => ({
        instruction: step.step || '',
        expectedResults: Array.isArray(step.expect) ? step.expect : [],
      })),
    })),
  }));
}
